import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

const Pagination = ({
  totalPosts,
  postsPerPage,
  currentPage,
  setCurrentPage,
}) => {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const getPageNumbers = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage > totalPages - 4) {
      return [
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    return [currentPage, currentPage + 1, "...", totalPages - 1, totalPages];
  };

  const pageNumbers = getPageNumbers();

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="flex justify-center items-center space-x-2">
      {totalPosts > 5 && currentPage > 1 ? (
        <button
          className="flex flex-col items-center h-6 p-2 w-[30px] rounded-md bg-white shadow-xl"
          onClick={handlePrev}
        >
          <FontAwesomeIcon icon={faChevronLeft} className="h-2" />
        </button>
      ) : (
        <div className="flex flex-col items-center h-6 p-2 w-[30px] rounded-md bg-transparent"></div>
      )}

      {pageNumbers.map((page, index) =>
        typeof page === "string" ? (
          <span key={index} className="px-5 py-3">
            {page}
          </span>
        ) : (
          <button
            className={classNames(
              "h-7 w-[35px] rounded-md font-main font-medium text-lg shadow-md",
              {
                "font-main  text-white bg-orange-500 h-6 w-[30px] shadow-none":
                  page === currentPage,
              }
            )}
            key={index}
            onClick={() => setCurrentPage(page)}
          >
            {page}
          </button>
        )
      )}

      {totalPosts > 5 && currentPage < totalPages ? (
        <button
          className="flex flex-col items-center h-6 p-2 w-[30px] rounded-md bg-white shadow-xl"
          onClick={handleNext}
        >
          <FontAwesomeIcon icon={faChevronRight} className="h-2" />
        </button>
      ) : (
        <div className="flex flex-col items-center h-6 p-2 w-[30px] rounded-md bg-transparent"></div>
      )}
    </div>
  );
};

export default Pagination;
